<div class="control-message-item" *ngIf="errorMessage !== null">
  <span class="form-error" style="font-size: 1rem;">{{errorMessage()}}</span>
</div>